import React, { useState } from 'react';
import { useAuth } from 'context/auth';
import styles from './styles.module.css';
import { Icon } from 'common/icon';
import { ComplaintItem } from 'components/template/casino/casino-complaints';
import { Button } from 'common/new-button';
import { useLoginModal } from 'hooks/useLoginModal';
import { LoginModal } from 'components/modal/login';
import { TopicModal } from 'components/modal/topic';
import { IUser } from 'constants/types';
import { Header } from 'components/slider/header';

export const MyTopicsSection = ({ anchor }: { anchor?: string }) => {
  const { isLoggedIn } = useAuth();
  const [isModalVisible, setModalVisible] = useState<boolean>(false);
  const {
    isLoginVisible,
    handleCloseLoginModal,
    handleConfirmLoginModal,
    handleVisibleLoginModal,
  } = useLoginModal();
  return (
    <div className={styles.wrapper} id={anchor}>
      <span className={styles.title}>My topics</span>
      <div className={styles.container}>
        <div className={styles.innerRow}>
          <div className={styles.leftContent}>
            <div className={styles.iconTextGroup}>
              <div className={styles.iconMessage}>
                <Icon.MessageFourth width="30" height="30" />
              </div>
              <div className={styles.textContent}>
                Do you have a question? Create a topic and get support from
                community members or our experienced admins
              </div>
            </div>
          </div>
          <div className={styles.button}>
            <Icon.MessageThird width="16" height="16" />
            <Button
              className={styles.buttonText}
              text={'Ask a question'}
              onClick={() =>
                isLoggedIn ? setModalVisible(true) : handleVisibleLoginModal()
              }
            />
          </div>
        </div>
      </div>
      <TopicModal isVisible={isModalVisible} setVisible={setModalVisible} />
      <LoginModal
        isVisible={isLoginVisible}
        onClose={handleCloseLoginModal}
        confirmOnClick={handleConfirmLoginModal}
      />
    </div>
  );
};

export const Topics = ({ user }: { user?: IUser }) => {
  if (!user?.questions || user.questions.length === 0) return null;
  return (
    <div>
      <Header name={'Topics'} count={user?.questions?.length} isSmallName />
      {user?.questions?.map((item) => (
        <ComplaintItem
          key={item?._id}
          item={{ ...item, user }}
          routeTo={'question'}
          rounded
        />
      ))}
    </div>
  );
};

export const Complaints = ({ user }: { user?: IUser }) => {
  if (!user?.complaints || user.complaints.length === 0) return null;
  return (
    <div style={{ paddingBottom: 20 }}>
      <Header
        name={'Casino Complaints'}
        count={user?.complaints?.length}
        isSmallName
      />
      {user?.complaints
        ?.filter((item) => !item?.parent)
        ?.map((item) => (
          <ComplaintItem
            key={item?._id}
            hideRepliesCount
            item={{ ...item, user }}
            routeTo={'complaint'}
            rounded
          />
        ))}
    </div>
  );
};
